import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import PageTitle from '../controls/PageTitle'
import LoadingStatus from '../controls/LoadingStatusContainer'
import BreadcrumbContainer from '../controls/BreadcrumbContainer'
import CommunityUsersView from './CommunityUsersView'
import * as CommunityActionCreators from '../../actions/community'
import * as PermissionActionCreators from '../../actions/permission'

class CommunityUsersPage extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    communities: PropTypes.object.isRequired,
    communityActions: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    permissionActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      communities: state.communities,
      roles: state.roles,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
      permissionActions: bindActionCreators(PermissionActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.update(this.communityId())
  }

  componentDidUpdate(prevProps) {
    this.update(this.props.match.params.communityId, prevProps.match.params.communityId)
  }

  update(id, prevId) {
    const { communityActions, permissionActions } = this.props
    if (id !== prevId) {
      communityActions.fetchCommunity(id)
      // Load roles
      permissionActions.listRoles()
    }
  }

  communityId() {
    return parseInt(this.props.match.params.communityId, 10)
  }

  community() {
    const { communities } = this.props
    return communities[this.communityId()] || {}
  }

  render() {
    const { roles, communityActions } = this.props
    const community = this.community()

    return (
      <>
        <PageTitle title="Users" />
        <LoadingStatus />
        <BreadcrumbContainer items={[
          { title: `${community.name} Users` },
        ]}
        />
        <CommunityUsersView community={community} roles={roles} onSave={communityActions.saveCommunity} />
      </>
    )
  }
}

export default connect(
  CommunityUsersPage.mapStateToProps,
  CommunityUsersPage.mapDispatchToProps,
)(CommunityUsersPage)
